export default class FormStream {
	refresh(element) {
		const form = element.closest('form')
		form.action = form.action + '/form_refresh'
		form.requestSubmit()
	}
}

window.FormStream = new FormStream()
